import { useSelector } from 'react-redux';

import FastTracks from '../../../FastTracks';
import NarrativesChat from '../../index';

// Temporary component to show Chat UI for Numeration.
// Landing page and Chat UI will need to be consolidated for final version.
// FastTracks is a deprecated name and should go away.
const NarrativesRoute = () => {
  const canAccessChat = useSelector((state) => state.user.data?.permissions?.canAccessChat);

  return canAccessChat ? <NarrativesChat /> : <FastTracks />;
};

export default NarrativesRoute;
